var _defs, _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehousestation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "10_\u5E93\u623F\u5DE5\u4F5C\u7AD9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.75,
    y: 23.68,
    width: 32,
    height: 24,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,35.86H42a2,2,0,0,0,2-2v-8a2,2,0,0,0-2-2H22a2,2,0,0,0-2,2v8A2,2,0,0,0,22,35.86Zm2-8H40v4H24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,51.87H42a2,2,0,0,0,2-2v-8a2,2,0,0,0-2-2H22a2,2,0,0,0-2,2v8A2,2,0,0,0,22,51.87Zm2-8H40v4H24Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.22,20.13,52,16.7a.69.69,0,0,0,0-.13V10a2,2,0,0,0-2-2H50a2,2,0,0,0-2,2v4.09L33.17,4.3a2,2,0,0,0-1.89-.16,1.85,1.85,0,0,0-.45.21l-24,15.78a2,2,0,0,0,2.2,3.34L12,21.54V54.39C12,57.5,14.24,60,17,60H47c2.76,0,5-2.52,5-5.63V30a2,2,0,1,0-4,0V54.39c0,.93-.53,1.63-1,1.63H17c-.47,0-1-.7-1-1.63V18.91L32,8.35,55,23.47a2,2,0,0,0,2.2-3.34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehousestation);
export default __webpack_public_path__ + "static/media/warehousestation.4a01d5d1.svg";
export { ForwardRef as ReactComponent };